import {
  SettingsModel,
  SettingsOrderDiscount
} from '@core/models/settings.model';

export class SetSettingsData {
  static readonly type = '[Settings] SetSettingsData';
  constructor(public settings: SettingsModel | null) {}
}

export class UpdateInstallPrompt {
  static readonly type = '[Settings] UpdateInstallPrompt';
  constructor(public isVisible: boolean) {}
}

export class SetActiveProperty {
  static readonly type = '[Settings] SetActiveProperty';
}

export class SetOrderDiscount {
  static readonly type = '[Settings] SetOrderDiscount';
  constructor(public orderDiscount: SettingsOrderDiscount) {}
}

export class GetCategories {
  static readonly type = '[Settings] GetCategories';
}
